import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

function App() {
  const [city, setCity] = useState('');
  const [weather, setWeather] = useState(null);
  const [history, setHistory] = useState([]);
  const [darkMode, setDarkMode] = useState(false); // 🌙 Dark mode state

  useEffect(() => {
    fetchHistory();
  }, []);

  const fetchHistory = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/history`);
      setHistory(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const getWeather = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/weather/${city}`);
      setWeather(res.data);
      setCity('');
      fetchHistory();
    } catch (err) {
      alert('City not found');
    }
  };

  const deleteHistoryItem = async (id) => {
    try {
      await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/history/${id}`);
      fetchHistory();
    } catch (err) {
      console.error(err);
    }
  };

  const clearHistory = async () => {
    if (window.confirm("Are you sure you want to clear all history?")) {
      try {
        await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/history`);
        setHistory([]);
      } catch (err) {
        console.error(err);
      }
    }
  };

  const getWeatherIcon = (desc) => {
    if (!desc) return "🌍";
    desc = desc.toLowerCase();
    if (desc.includes("cloud")) return "☁️";
    if (desc.includes("rain")) return "🌧";
    if (desc.includes("clear")) return "☀️";
    if (desc.includes("snow")) return "❄️";
    return "🌍";
  };

  return (
    <div className={`app-container d-flex flex-column align-items-center justify-content-center ${darkMode ? "dark-mode" : ""}`}>
      <div className="weather-card shadow-lg p-4 rounded">
        {/* Header + Dark Mode Toggle */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2>🌤 Weather App</h2>
          <button
            className="btn btn-sm btn-secondary"
            onClick={() => setDarkMode(!darkMode)}
          >
            {darkMode ? "☀️ Light Mode" : "🌙 Dark Mode"}
          </button>
        </div>

        {/* Search Form */}
        <form onSubmit={getWeather} className="d-flex mb-4">
          <input
            type="text"
            value={city}
            onChange={(e) => setCity(e.target.value)}
            placeholder="Enter city"
            required
            className="form-control me-2"
          />
          <button type="submit" className="btn btn-primary">Search</button>
        </form>

        {/* Weather Result */}
        {weather && (
          <div className="weather-result card text-center p-3 mb-4 shadow-sm">
            <h2>{getWeatherIcon(weather.description)} {weather.city}</h2>
            <p className="fs-4 text-primary">🌡 {weather.temperature} °C</p>
            <p className="text-muted">{weather.description}</p>
          </div>
        )}

        {/* History */}
        <div className="d-flex justify-content-between align-items-center mt-4">
          <h5>📜 Last 10 Searches</h5>
          {history.length > 0 && (
            <button className="btn btn-sm btn-danger" onClick={clearHistory}>
              🗑 Clear All
            </button>
          )}
        </div>

        <ul className="list-group mt-2 history-list">
          {history.map(item => (
            <li key={item._id} className="list-group-item d-flex justify-content-between align-items-center">
              <div>{getWeatherIcon(item.description)} <strong>{item.city}</strong> — {item.temperature} °C ({item.description})</div>
              <button className="btn btn-sm btn-outline-danger" onClick={() => deleteHistoryItem(item._id)}>🗑 Delete</button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default App;
